module.exports = __webpack_public_path__ + "static/media/works-slider-img2.e8ef1ffa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/works-slider-img2.png
// module id = 1017
// module chunks = 0